/* eslint react/sort-comp: 0 */
import React from 'react'
import { connect } from 'react-redux'
import { Popover } from '@material-ui/core'
import { getIn } from 'utils'
import { isEqual, once } from 'lodash'
import {
  cancelProvisionalChanges,
  confirmProvisionalChanges
} from 'pages/SalesOrder/actions'
import QuantityCell from './QuantityCell'

const mapStateToProps = (state, ownProps) => {
  const { form } = ownProps
  const formState = getIn(state, `ddiForm.${form}`)
  const isEditing = getIn(formState, 'isEditing') || false

  return {
    isEditing
  }
}

class QuantityCellWrapper extends React.Component {
  static defaultProps = {
    style: {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      textAlign: 'center',
      width: '100%'
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      open: true,
      inquiryMode: props.hasRecord && !props.isEditing
    }
    console.log('quantity cell wrapper constructed')
  }

  componentDidMount() {
    if (this.state.inquiryMode) {
      window.addEventListener('keydown', this.onKeyup)
    }
  }

  componentWillUnmount() {
    if (this.state.inquiryMode) {
      window.removeEventListener('keydown', this.onKeyup)
    }
  }

  onKeyup = event => {
    if (event.key === 'Tab') {
      this.tabToNext(this.props.api, true, event.shiftKey)
    }
  }

  edited = false

  setEdited = once(() => {
    this.edited = true
  })

  getValue() {
    /* 
      can't return 'undefined' here or it wipes out
      the entire inventory object on closing the 
      Quantity cell. Probably not what we wanna do
      here -- SVE 10/21/2019 
    */
    return this.props.value
    // return undefined
  }

  onCancelButtonClicked = () => {
    const { dispatch, form, api } = this.props
    // if (this.edited) {
    dispatch(cancelProvisionalChanges.try(form))
    // }
    this.edited = false
    api.stopEditing(true)
    this.tabToNext(api)
  }

  tabToNext = (api, wasBlurred, shiftKey) => {
    const { props } = this
    // console.log(wasBlurred)
    if (typeof wasBlurred !== 'boolean') {
      wasBlurred = false
    }

    this.setState({ open: false }, () => {
      api.stopEditing()
      // if (wasBlurred && props.data.promptForPrice && api.startEditingCell) {
      if (wasBlurred) {
        setTimeout(
          () => api[shiftKey ? 'tabToPreviousCell' : 'tabToNextCell'](),
          0
        )
      }
      // }
    })
  }

  handleClose = async (wasBlurred, shiftKey) => {
    const { dispatch, form, api } = this.props

    if (this.edited) {
      await dispatch(confirmProvisionalChanges.try(form))
    }
    api.stopEditing(true)
    this.tabToNext(api, wasBlurred, shiftKey)
  }

  render() {
    // const { anchorEl } = this.state
    console.log('quantity cell wrapper rendered', this.props)
    return (
      <Popover
        open={this.state.open}
        anchorEl={this.props.eGridCell}
        onClose={this.handleClose}
      >
        <div style={this.props.style}>
          <QuantityCell
            warehouseId={this.props.data.warehouseIdResolved}
            // value={this.props.value}
            handleClose={this.handleClose}
            dispatch={this.props.dispatch}
            node={this.props.node}
            form={this.props.form}
            lineNumber={this.props.data.lineNumber}
            // rowData={this.props.data}
            rowId={this.props.data.rowId}
            onCancelButtonClicked={this.onCancelButtonClicked}
            edited={this.edited}
            setEdited={this.setEdited}
            // inventory={this.props.data.inventory}
            inquiryMode={this.state.inquiryMode}
            canChangeQuantity={this.props.data.canChangeQuantity}
          />
        </div>
      </Popover>
    )
  }
}

export default connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true }
)(QuantityCellWrapper)
// export default QuantityCellWrapper
